/* eslint-disable jsx-a11y/anchor-is-valid */
import axios from "axios";
import Spinner from "helpers/Spinner";


import { baseUrl,localUrl } from "@ora/recursos/src/helpers/Url";

import { nanoid } from "nanoid";
import React, { cloneElement, Component, createRef } from "react";
import { connect } from "react-redux";
import helperStorage from "./helperStorage";
import { import_current_tab, import_set_data, import_casa, import_setRecursos } from './store'
class ImportarStep1 extends Component {
  state = {
    nameCurrentFile: 'Buscar',
    filePreUploaded: false,
    startUpload: false,
    percentageUpload: 0,
    selTypeInformation: -1,
    estandar:"",
    fromDataImport: {}
  }
  selTypeInformation = null
  constructor (props) {
    super(props)
    
    this.selTypeInformation = createRef()
  }
  componentDidMount () {
    // this.props.COptionTypeInformation.bind(this)
    
    if (this.props.COptionTypeInformation.length === 1) {
      
      this.selTypeInformation.current.value = +this.props.COptionTypeInformation[0].props.value

      // var index = evt.target.selectedIndex;
      // var optionElement = evt.target.childNodes[index]
      // var estandar =  optionElement.getAttribute('estandar');
      // var estandar =  'fff';
      this.props.import_set_data({
        typeInformation: this.selTypeInformation.current.value,
        estandar: this.props.COptionTypeInformation[0].props.estandar
      })
      this.setState({
        estandar: this.props.COptionTypeInformation[0].props.estandar
      });


    }
    if (+this.props.importData.typeInformation > 0)
      this.selTypeInformation.current.value =this.props.importData.typeInformation 
    this.setState({
      selTypeInformation: this.selTypeInformation.current.value
    })  
    // this.selTypeInformation.current.value = 7
  }
  onChange = (evt) => {
    console.log(evt.target)

    const value = evt.target.type === 'checkbox' ? evt.target.checked : evt.target.value;
    
    if (evt.target.name.toString() === 'file-doc') {
        //change name curretn file
        let tn = 'Buscar'
        if (evt.target.files[0]) {
            tn = evt.target.files[0].name
        }
        this.setState({
            nameCurrentFile: tn
        })
    }

    if (evt.target.name === 'selTypeInformation') {
      var index = evt.target.selectedIndex;
      var optionElement = evt.target.childNodes[index]
      var estandar =  optionElement.getAttribute('estandar');
      this.props.import_set_data({
        typeInformation: evt.target.value,
        estandar: estandar
      })
      this.setState({
        estandar: estandar
      });
      // this.getResourceByTypeIOfformation(evt.target.value)
    }


    if (evt.target.name === 'file-doc') {
      this.setState({
        filePreUploaded: true
      })
    }
    this.setState({
      [evt.target.name]: value,
    });
  }
  gotToStep2 = () => {
    return this.state.filePreUploaded && this.state.selTypeInformation !== -1
  }
 
  textprueba = () => {
    console.log(this.props)
    console.log(this.state)
    return this.props.currentTab;
  }
  onSubmit_Step1 = (event) => {
    event.preventDefault(0)
    Spinner.show()
        // let sendData = this.state
        this.setState({
          startUpload: true
        })
        let sendData = new FormData(document.getElementById('frmImportStep1'));
        sendData.append('tempid', 'IDT' + nanoid(10).toString())
        axios.post(baseUrl('cites/import/file?step=1'),sendData, {
          onUploadProgress: (progressEvent) => {
            var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
            // console.log(percentCompleted)
            this.setState({
              percentageUpload: percentCompleted
            })
          }
        }).then(res => {
          Spinner.hide()
          this.setState({
            startUpload: false,
            percentageUpload: 0
          })
          if (res.data.success) {
            this.props.import_set_data({
              idFile: res.data.data.id,
              idFileName: res.data.data.namefile,
              fileName: res.data.data.file,
              // typeInformation: res.data.data.selTypeInformation,
              typeInformationName: res.data.data.variable.var_txt_name,
              typeFile: res.data.data.typeFile,
              table: res.data.data.table
              // resource: res.data.data.namefile,
            })
            
            this.props.import_current_tab(2)
            // this.props.import_casa('new csa')
            // helperStorage.set({
            //   id: res.data.id,
            //   filename: res.data.filename,
            //   step: 1
            // })

            //set reducer
          

          
          }
        
        })
  }
  render () {
    return (
      <div id={ this.props.id } className={this.props.className}>

        <form id="frmImportStep1" onSubmit={ this.onSubmit_Step1 }>
          <div className="field is-horizontal">
            <div className="field-label is-normal"><label className="label">Seleccione el
                tipo de información</label></div>
            <div className="field-body">
              <div className="field">

                <div className="control">
                  <span className="select is-danger is-empty">
                    <select onChange={this.onChange} id="selTypeInformation" ref={ this.selTypeInformation } name="selTypeInformation" required="required" >
                      <option value="-1">- Seleccionar -</option>
                      {this.props.COptionTypeInformation}
                    </select>

                  </span>
                  { this.state.selTypeInformation!=-1?
                    <a className="mt-3" href={baseUrl("aro/filemetadata/"+this.state.estandar+"/recursos")}>Descargar Metadatos</a>:""
                  }
                  
                </div>

              </div>
              <div className="field">
                <div className="notification is-info">
                  Antes de subir el archivo debe <strong className="has-text-warning"> revisar que sus datos estén formateados según la metadata</strong> del tipo de información que seleccione.  Para revisar presione en “Descargar Metadatos”
                </div>
              </div>

            </div>

          </div>

          <hr />
          <div className="field has-check is-horizontal">
            <div className="field-label"><label className="label">Seleccione tipo de archivo</label></div>
            <div className="field-body">
              <div className="field">
                <div className="field is-grouped-multiline is-grouped">
                  <div className="control"><label className="b-radio radio"><input type="radio" name="radio-type-file"
                        defaultChecked value="excel" />
                      <span className="check"></span>
                      <span className="control-label">Excel</span>
                    </label></div>
                  <div className="control"><label className="b-radio radio"><input type="radio" name="radio-type-file"
                        value="delimitado" />
                      <span className="check"></span>
                      <span className="control-label">Delimitado por ;</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div className="field is-horizontal">
            <div className="field-label is-normal"><label className="label">Seleccione archivo</label></div>
            <div className="field-body">
              <div className="field">
                <div className="field file">
                  <label className="upload control">
                    <a className="button is-primary">
                      <span className="icon"><i className="mdi mdi-upload"></i></span>
                      <span>{ this.state.nameCurrentFile }</span>
                    </a>
                    <input onChange={this.onChange} id="file-doc" name="file-doc" type="file" />

                  </label>
                </div>
                <p className="help">Tamaño máximo 100MB</p>
                { this.state.startUpload && <progress className="progress is-small" value={ this.state.percentageUpload
                  } max="100">{ this.state.percentageUpload }%</progress>}
              </div>
            </div>
          </div>
          <hr />
          <div className="field is-horizontal">

            <div className="field-body">
              <div className="field">

                <div className="field">

                  <div className="field-body is-pulled-right">
                    <div className="field is-grouped">

                      <div className="control">
                        <button type="submit" disabled={!this.gotToStep2()} className="button is-primary">
                          <span>Cargar archivo</span>
                        </button>
                      </div>

                    </div>
                  </div>

                </div>

              </div>
            </div>

          </div>
        </form>
      </div>
    )
  }
}

const mapStateToProps = (state /*, ownProps*/) => {
    return {
      currentTab: state.reducerTab.tab,
      collectTab: state.reducerTab.targets,
      importData: state.reducerData
      // currentTab: state.tab,
    }
  }
export default connect(mapStateToProps, {
  import_current_tab, 
  import_set_data, 
  import_casa,
  import_setRecursos
 })(ImportarStep1)